<template>
  <div class="contact">
    <form
      @submit.prevent="submitForm"
      autocomplete="off"
      enctype="multipart/form-data"
      class="work-form"
    >
      <input
        type="text"
        placeholder="Nome"
        required
        v-model="form.name"
        class="form-control"
        aria-label="Nome"
      />
      <input
        type="email"
        placeholder="E-mail"
        class="form-control"
        required
        v-model="form.email"
        aria-label="E-mail"
      />
      <the-mask
        aria-label="Telefone"
        :masked="true"
        class="form-control"
        placeholder="Telefone"
        v-model="form.phone"
        :mask="['(##) ####-####', '(##) #####-####']"
        required
      />
      <select
        class="form-control"
        @change="changeCity($event)"
        id="select-state"
        aria-label="Estado"
        v-model="form.state"
        required
      >
        <option disabled value="">Por favor, selecione um estado</option>
        <option v-for="(item, index) in states" :key="index" :value="item.nome">
          {{ item.nome }}
        </option>
      </select>
      <select
        class="form-control"
        aria-label="Cidade"
        v-model="form.city"
        required
      >
        <option disabled value="">
          {{ placeholder_city }}
        </option>
        <option
          v-for="(item, index) in cities_state.cidades"
          :key="index"
          :value="item"
        >
          {{ item }}
        </option>
      </select>
      <div
        class="
          d-xl-flex d-block
          flex-xl-row flex-column
          justify-content-between
        "
      >
        <input
          type="file"
          ref="file"
          id="file-input"
          placeholder="Currículo"
          class="form-control"
          required
          aria-label="Currículo"
        />
      </div>
      <textarea
        rows="4"
        v-model="form.message"
        class="form-control"
        placeholder="Mensagem"
        required
        aria-label="Mensagem"
      ></textarea>
      <div class="w-100 text-center">
        <button class="cta cta-button" type="submit" :disabled="disabled">
          {{ button }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import cities_json from "../cms/locations/city.json";
import axios from "axios";

export default {
  props: ["endpoint"],
  data() {
    return {
      button: "Enviar mensagem",
      disabled: false,
      states: cities_json.estados,
      cities_state: "",
      placeholder_city: "Por favor, selecione um estado primeiro",
      form: {
        state: "",
        city: "",
        name: "",
        email: "",
        phone: "",
        message: "",
        file: "",
      },
    };
  },
  methods: {
    changeCity(event) {
      this.placeholder_city = "Por favor, selecione uma cidade";
      this.cities_state = this.states.filter(function (state) {
        return state.nome === event.target.value;
      });
      this.cities_state = this.cities_state[0];
    },
    resetForm() {
      this.form = {
        state: "",
        city: "",
        name: "",
        email: "",
        phone: "",
        message: "",
      };
    },
    getExtension(path) {
      var basename = path.split(/[\\/]/).pop(),
        pos = basename.lastIndexOf(".");

      if (basename === "" || pos < 1) return "";

      return basename.slice(pos + 1);
    },
    async submitForm() {
      this.button = "Enviando...";
      this.disabled = true;

      //Configures the sending of the file
      this.form.file = this.$refs.file.files[0];
      let formData = new FormData();
      Object.keys(this.form).map((key) => {
        if (key === "file") {
          let file = this.form.file;
          if (this.form.file) {
            if (this.form.file.name) {
              formData.append(
                `file`,
                file,
                `${new Date().getTime()}.${this.getExtension(
                  this.form.file.name
                )}`
              );
            }
          }
        } else {
          if (this.form[key]) {
            formData.append(key, this.form[key]);
          }
        }
      });

      await axios
        .post(this.endpoint, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.resetForm();
          document.getElementById("file-input").value = "";
          var msg =
            "Você entrou em contato com a OdontoTop, agora é só aguardar que entraremos em contato com você.";
          this.$swal("Enviado :)", msg, "success");
        })
        .catch((e) => {
          var msg =
            "Houve um erro ao enviar seus dados! Por favor, tente novamente.";

          if (e?.response?.data?.problem) {
            msg = "Seu arquivo precisa ser nos formatos .doc, .docx ou .pdf";
          }
          this.$swal("Oops!", msg, "error");
        })
        .finally(() => {
          this.button = "Enviar mensagem";
          this.disabled = false;
        });
    },
  },
};
</script>